import React from 'react';

import { AiIcon } from '@/shared/assets/icons/ai-icon';
import { BackupIcon } from '@/shared/assets/icons/backup-icon';
import { CodeIcon } from '@/shared/assets/icons/code-icon';
import { ConnectivityIcon } from '@/shared/assets/icons/connectivity-icon';
import { ConversionJobIcon } from '@/shared/assets/icons/conversion-job-icon';
import { DeploymentIcon } from '@/shared/assets/icons/deployment-icon';
import { DeviceSnapshotIcon } from '@/shared/assets/icons/device-snapshot-icon';
import { DevicesIcon } from '@/shared/assets/icons/devices-icon';
import { DocumentsIcon } from '@/shared/assets/icons/documents-icon';
import { EnterpriseAuthIcon } from '@/shared/assets/icons/enterprise-auth-icon';
import { FileIcon } from '@/shared/assets/icons/file-icon';
import { FTPBackUpIcon } from '@/shared/assets/icons/ftp-backup-icon';
import { GatewayIcon } from '@/shared/assets/icons/gateway-icon';
import { HeadsetIcon } from '@/shared/assets/icons/headset-icon';
import { IdeaasIcon } from '@/shared/assets/icons/ideaas-icon';
import { LicenseIcon } from '@/shared/assets/icons/license-icon';
import { LockIcon } from '@/shared/assets/icons/lock-icon';
import { MergeIcon } from '@/shared/assets/icons/merge-icon';
import { PipelinesIcon } from '@/shared/assets/icons/pipelines-icon';
import { PlayCircleIcon } from '@/shared/assets/icons/play-circle-icon';
import { ProjectBackupIcon } from '@/shared/assets/icons/project-backup-icon';
import { ProjectsIcon } from '@/shared/assets/icons/projects-icon';
import { RefreshIcon } from '@/shared/assets/icons/refresh-icon';
import { ResetPasswordIcon } from '@/shared/assets/icons/reset-password-icon';
import { RestoreFtpIcon } from '@/shared/assets/icons/restore-ftp-icon';
import { RestoreSmbIcon } from '@/shared/assets/icons/restore-smb-icon';
import { SettingsIcon } from '@/shared/assets/icons/settings-icon';
import { ShowIcon } from '@/shared/assets/icons/show-icon';
import { SmbBackupIcon } from '@/shared/assets/icons/smb-backup-icon';
import { StorageIcon } from '@/shared/assets/icons/storage-icon';
import { UpdateIcon } from '@/shared/assets/icons/update-icon';
import { UserIcon } from '@/shared/assets/icons/user-icon';
import { UserRoleIcon } from '@/shared/assets/icons/user-role-icon';
import { VaultIcon } from '@/shared/assets/icons/vault-icon';
import { WorkstationIcon } from '@/shared/assets/icons/workstation-icon';
import { WriteVariablesIcon } from '@/shared/assets/icons/write-variables-icon';
import {
  TBillingFeatureIcon,
  TBillingFeatureUnitKey,
} from '@/shared/features/billing/hooks/use-billing-entities/use-billing-entities.types';
import { BillingFeatureEnum } from '@/shared/types/types.generated';

export const billingFeatureIcon: Partial<TBillingFeatureIcon> = {
  [BillingFeatureEnum.CreateAiCodeExplanation]: <AiIcon />,
  [BillingFeatureEnum.CreateDocument]: <DocumentsIcon />,
  [BillingFeatureEnum.CreateDocumentVersion]: <DocumentsIcon />,
  [BillingFeatureEnum.CreateProject]: <ProjectsIcon />,
  [BillingFeatureEnum.CreateProjectVersion]: <ProjectsIcon />,
  [BillingFeatureEnum.Device]: <DevicesIcon />,
  [BillingFeatureEnum.Document]: <DocumentsIcon />,
  [BillingFeatureEnum.EnterpriseAuth]: <EnterpriseAuthIcon />,
  [BillingFeatureEnum.Gateway]: <GatewayIcon />,
  [BillingFeatureEnum.LocalRunner]: <WorkstationIcon />,
  [BillingFeatureEnum.Project]: <ProjectsIcon />,
  [BillingFeatureEnum.Rbac]: <UserRoleIcon />,
  [BillingFeatureEnum.Recovery]: <RefreshIcon />,
  [BillingFeatureEnum.RunBackup]: <BackupIcon />,
  [BillingFeatureEnum.RunCompareProjectVersions]: <ConversionJobIcon />,
  [BillingFeatureEnum.RunDeployment]: <DeploymentIcon />,
  [BillingFeatureEnum.RunDevicePwRotation]: <ResetPasswordIcon />,
  [BillingFeatureEnum.RunDeviceSnapshot]: <DeviceSnapshotIcon />,
  [BillingFeatureEnum.RunDeviceSnapshotRestore]: <RefreshIcon />,
  [BillingFeatureEnum.RunFtpBackup]: <FTPBackUpIcon />,
  [BillingFeatureEnum.RunJob]: <PipelinesIcon />,
  [BillingFeatureEnum.RunMergeProjectVersions]: <MergeIcon />,
  [BillingFeatureEnum.RunReadDeviceVarList]: <CodeIcon />,
  [BillingFeatureEnum.RunSmbBackup]: <SmbBackupIcon />,
  [BillingFeatureEnum.RunUpdateDeviceFw]: <DevicesIcon />,
  [BillingFeatureEnum.RunUpdateProjectLibs]: <UpdateIcon />,
  [BillingFeatureEnum.RunWriteDeviceVarList]: <WriteVariablesIcon />,
  [BillingFeatureEnum.SecurityVault]: <VaultIcon />,
  [BillingFeatureEnum.SsoUser]: <EnterpriseAuthIcon />,
  [BillingFeatureEnum.Storage]: <StorageIcon />,
  [BillingFeatureEnum.TimeConnectivitySra]: <ConnectivityIcon />,
  [BillingFeatureEnum.TimeIdeaas]: <IdeaasIcon />,
  [BillingFeatureEnum.TimeIdeaasGraphics]: <IdeaasIcon />,
  [BillingFeatureEnum.TimeIdeaasSessionRecording]: <PlayCircleIcon />,
  [BillingFeatureEnum.TokenSdai]: <AiIcon />,
  [BillingFeatureEnum.User]: <UserIcon />,
  [BillingFeatureEnum.VersionPro]: <ShowIcon />,
  [BillingFeatureEnum.CreateDevice]: <DevicesIcon />,
  [BillingFeatureEnum.DeviceAgv]: <DevicesIcon />,
  [BillingFeatureEnum.DeviceCnc]: <DevicesIcon />,
  [BillingFeatureEnum.DeviceDrive]: <DevicesIcon />,
  [BillingFeatureEnum.DeviceHmi]: <DevicesIcon />,
  [BillingFeatureEnum.DeviceIndustrialSwitch]: <DevicesIcon />,
  [BillingFeatureEnum.DeviceIpc]: <DevicesIcon />,
  [BillingFeatureEnum.DeviceOther]: <DevicesIcon />,
  [BillingFeatureEnum.DevicePlc]: <DevicesIcon />,
  [BillingFeatureEnum.DeviceRobot]: <DevicesIcon />,
  [BillingFeatureEnum.DeviceScada]: <DevicesIcon />,
  [BillingFeatureEnum.DocumentVersion]: <FileIcon />,
  [BillingFeatureEnum.EnterpriseSupport]: <HeadsetIcon />,
  [BillingFeatureEnum.PocSupport]: <HeadsetIcon />,
  [BillingFeatureEnum.ProjectVersion]: <FileIcon />,
  [BillingFeatureEnum.RunConvertProject]: <ConversionJobIcon />,
  [BillingFeatureEnum.RunFtpRestore]: <RestoreFtpIcon />,
  [BillingFeatureEnum.RunProjectBackup]: <ProjectBackupIcon />,
  [BillingFeatureEnum.RunProjectDeployment]: <DeploymentIcon />,
  [BillingFeatureEnum.RunSmbRestore]: <RestoreSmbIcon />,
  [BillingFeatureEnum.RunUpdateProjectOpcUaInterface]: <PipelinesIcon />,
  [BillingFeatureEnum.RunValidateLicense]: <LicenseIcon />,
  [BillingFeatureEnum.Secret]: <LockIcon />,
  [BillingFeatureEnum.StandardUser]: <UserIcon />,
  [BillingFeatureEnum.TenantSetup]: <SettingsIcon />,
};

export const billingFeatureUnitTranslationKey: Partial<TBillingFeatureUnitKey> =
  {
    [BillingFeatureEnum.CreateAiCodeExplanation]: 'ai_explanations',
    [BillingFeatureEnum.CreateDocument]: 'document_creations',
    [BillingFeatureEnum.CreateDocumentVersion]: 'document_version_creations',
    [BillingFeatureEnum.CreateProject]: 'project_creations',
    [BillingFeatureEnum.CreateProjectVersion]: 'project_version_creations',
    [BillingFeatureEnum.Recovery]: 'jobs',
    [BillingFeatureEnum.RunBackup]: 'jobs',
    [BillingFeatureEnum.RunCompareProjectVersions]: 'version_comparisons',
    [BillingFeatureEnum.RunDeployment]: 'jobs',
    [BillingFeatureEnum.RunDevicePwRotation]: 'jobs',
    [BillingFeatureEnum.RunDeviceSnapshot]: 'jobs',
    [BillingFeatureEnum.RunDeviceSnapshotRestore]: 'jobs',
    [BillingFeatureEnum.RunFtpBackup]: 'jobs',
    [BillingFeatureEnum.RunJob]: 'jobs',
    [BillingFeatureEnum.RunMergeProjectVersions]: 'jobs',
    [BillingFeatureEnum.RunReadDeviceVarList]: 'jobs',
    [BillingFeatureEnum.RunSmbBackup]: 'jobs',
    [BillingFeatureEnum.RunUpdateDeviceFw]: 'jobs',
    [BillingFeatureEnum.RunUpdateProjectLibs]: 'jobs',
    [BillingFeatureEnum.RunWriteDeviceVarList]: 'jobs',
    [BillingFeatureEnum.SecurityVault]: 'vaults',
    [BillingFeatureEnum.SsoUser]: 'users',
    [BillingFeatureEnum.Storage]: 'bytes',
    [BillingFeatureEnum.TimeConnectivitySra]: 'minutes',
    [BillingFeatureEnum.TimeIdeaas]: 'minutes',
    [BillingFeatureEnum.TimeIdeaasGraphics]: 'minutes',
    [BillingFeatureEnum.TimeIdeaasSessionRecording]: 'minutes',
    [BillingFeatureEnum.TokenSdai]: 'tokens',
    [BillingFeatureEnum.User]: 'users',
    [BillingFeatureEnum.VersionPro]: 'project_versions',
    [BillingFeatureEnum.CreateDevice]: 'device_creations',
    [BillingFeatureEnum.DocumentVersion]: 'document_versions',
    [BillingFeatureEnum.EnterpriseSupport]: 'supports',
    [BillingFeatureEnum.PocSupport]: 'supports',
    [BillingFeatureEnum.ProjectVersion]: 'project_versions',
    [BillingFeatureEnum.RunConvertProject]: 'jobs',
    [BillingFeatureEnum.RunFtpRestore]: 'jobs',
    [BillingFeatureEnum.RunProjectBackup]: 'jobs',
    [BillingFeatureEnum.RunProjectDeployment]: 'jobs',
    [BillingFeatureEnum.RunSmbRestore]: 'jobs',
    [BillingFeatureEnum.RunUpdateProjectOpcUaInterface]: 'jobs',
    [BillingFeatureEnum.RunValidateLicense]: 'jobs',
    [BillingFeatureEnum.Secret]: 'secrets',
    [BillingFeatureEnum.StandardUser]: 'users',
  };

export const billingFeatureSortingOrder: Partial<
  Record<BillingFeatureEnum, number>
> = {
  [BillingFeatureEnum.CreateDevice]: 1,
  [BillingFeatureEnum.Device]: 1,
  [BillingFeatureEnum.DeviceAgv]: 1,
  [BillingFeatureEnum.DeviceCnc]: 1,
  [BillingFeatureEnum.DeviceDrive]: 1,
  [BillingFeatureEnum.DeviceHmi]: 1,
  [BillingFeatureEnum.DeviceIndustrialSwitch]: 1,
  [BillingFeatureEnum.DeviceIpc]: 1,
  [BillingFeatureEnum.DeviceOther]: 1,
  [BillingFeatureEnum.DevicePlc]: 1,
  [BillingFeatureEnum.DeviceRobot]: 1,
  [BillingFeatureEnum.DeviceScada]: 1,
  [BillingFeatureEnum.SsoUser]: 2,
  [BillingFeatureEnum.User]: 2,
  [BillingFeatureEnum.StandardUser]: 2,
};
